export default "__VITE_ASSET__DDL60K$y__"